export default __webpack_public_path__ + "static/media/upload-payments.50c71a97.svg";